import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';
import './Booking.css';

// ─── CalendarConnectSuccess ──────────────────────────────────────────────────

export const CalendarConnectSuccess: React.FC = () => (
  <div className="bk-page">
    <div className="bk-card">
      <div className="bk-success-icon">
        <CheckCircle size={52} />
      </div>
      <h2 className="bk-success-title">Calendar connected</h2>
      <p className="bk-success-msg">
        Your calendar is connected. We&apos;ve emailed you a link to manage your availability.
      </p>
    </div>
  </div>
);

// ─── CalendarConnectError ────────────────────────────────────────────────────

const ERROR_MESSAGES: Record<string, string> = {
  resource_gone: 'This invite is no longer active. Please ask your admin to resend the calendar invite.',
  token_exchange:
    "The connection didn't complete — this can happen if you cancelled or the sign-in timed out. Please ask for a fresh invite link.",
};

export const CalendarConnectError: React.FC = () => {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason') ?? '';
  const message =
    ERROR_MESSAGES[reason] ??
    'Something went wrong connecting your calendar. Please ask for a fresh invite link.';

  return (
    <div className="bk-page">
      <div className="bk-card">
        <div className="bk-success-icon" style={{ color: 'var(--danger)' }}>
          <XCircle size={52} />
        </div>
        <h2 className="bk-success-title">Connection failed</h2>
        <p className="bk-success-msg">{message}</p>
      </div>
    </div>
  );
};
